export enum AnalyticsCategory {
    Onboarding = 'onboarding'
}

export enum AnalyticsOnboardingEventName {
    FirstLogin = 'first_login',
    AccountCreated = 'account_created'
}

export type AnalyticsEventName = AnalyticsOnboardingEventName;